import { useState, useEffect, useCallback } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'

import { setDefaultSalesFunnel } from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useSetDefaultSalesFunnel = () => {
  const dispatch = useAppDispatch()

  const [id, setId] = useState<string>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeSetDefault = useCallback(
    (newId: string) => {
      if (status != 'pending') setId(newId)
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    if (id) {
      const execute = async () => {
        try {
          const result = await dispatch(setDefaultSalesFunnel(id))

          if (mounted) {
            unwrapResult(result)
            setStatus('success')
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setId(undefined)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, id])

  return executeSetDefault
}
